import styled from 'styled-components/macro';

export const ContractBlockContainer = styled.div`
  padding: 1rem;
`;
